import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { NavigationProvider } from './NavigationContext';
import Footer from '../components/Footer/Main';
import HeaderSwitcher from '../components/headerone/Main';
import Hometwo from '../components/hometwo/Main';
import Pageabout from '../components/pages/about/Main';
import PrivacyPolicy from '../components/pages/privacy/Main';
import Team from '../components/pages/team/Main';
import Teamdetails from '../components/pages/Teamdetails/Main';
import Portfolio from '../components/pages/Portfolio/Main';
import Portfoliodetails from '../components/pages/portfoliodetails/Main';
import Causes from '../components/pages/causes/Main';
import Causesdetails from '../components/pages/causesdetails/Main';
import Services from '../components/pages/services/Main';
import Forms from '../components/pages/forms/Main';
import Departments from '../components/pages/departments/Main';

// Forms
import CommercialPermit from '../components/pages/forms/pages/CommercialPermit'
import CombinationFamilyPermit from '../components/pages/forms/pages/CombinationFamilyPermit'
import FamilyAssistanceApplication from '../components/pages/forms/pages/FamilyAssistanceApp'
import MedicaidChipApplication from '../components/pages/forms/pages/MedicaidChip'
import UndergradAdmissionApplication from '../components/pages/forms/pages/UndergraduateAppGTSU';
import GraduateAdmissionApplication from '../components/pages/forms/pages/GraduateAppGTSU';
import LicenseIdUpdateApplication from '../components/pages/forms/pages/LicenseIDUpdate';
import TitleRegistration from '../components/pages/forms/pages/TitleRegistration';

// Department Pages
import Housing from '../components/pages/departmentdetails/Housing';
import PublicSafety from '../components/pages/departmentdetails/PublicSafety';
import EmergencyManagement from '../components/pages/departmentdetails/EmergencyManagement';
import EducationYouthServices from '../components/pages/departmentdetails/EducationYouthServices';
import EmploymentWorkforce from '../components/pages/departmentdetails/EmploymentWorkforce';
import FamilyCommunityServices from '../components/pages/departmentdetails/FamilyCommunityServices';
import InnovationTechnology from '../components/pages/departmentdetails/InnovationTechnology';
import VeteransAffairs from '../components/pages/departmentdetails/VeteransAffairs';
import HealthHumanServices from '../components/pages/departmentdetails/HealthHumanServices';
import SeniorServices from '../components/pages/departmentdetails/SeniorServices';
import DMV from '../components/pages/departmentdetails/MotorVehicles';

// Sub-Department Pages
import PublicHealthInitiatives from '../components/pages/departmentdetails/subdepartment/PublicHealthInitiatives';
import MentalHealthAndSubstanceAbuse from '../components/pages/departmentdetails/subdepartment/MentalHealthAndSubstanceAbuse';
import FamilyCommunityHealth from '../components/pages/departmentdetails/subdepartment/FamilyCommunityHealth';
import EmergencyHealthResponse from '../components/pages/departmentdetails/subdepartment/EmergencyHealthResponse';
import CommunityPolicing from '../components/pages/departmentdetails/subdepartment/CommunityPolicing';
import FireRescue from '../components/pages/departmentdetails/subdepartment/FireRescue';
import TrafficRoadSafety from '../components/pages/departmentdetails/subdepartment/TrafficRoadSafety';
import DisasterResponseRecovery from '../components/pages/departmentdetails/subdepartment/DisasterResponseRecovery';
import AffordableHousingPrograms from '../components/pages/departmentdetails/subdepartment/AffordableHousingPrograms';
import CommunityDevelopmentRevitalization from '../components/pages/departmentdetails/subdepartment/CommunityDevelopmentRevitalization';
import TenantRightsRentalAssistance from '../components/pages/departmentdetails/subdepartment/TenantRightsRentalAssistance';
import ZoningPermits from '../components/pages/departmentdetails/subdepartment/ZoningPermits';
import JobTrainingSkills from '../components/pages/departmentdetails/subdepartment/JobTrainingSkills';
import YouthStudentEmployment from '../components/pages/departmentdetails/subdepartment/YouthStudentEmployment';
import CareerCounselingJobPlacement from '../components/pages/departmentdetails/subdepartment/CareerCounselingJobPlacement';
import EmployerPartnershipsResources from '../components/pages/departmentdetails/subdepartment/EmployerPartnershipsResources';
import FamilySupportWelfare from '../components/pages/departmentdetails/subdepartment/FamilySupportWelfare';
import ChildYouthDevelopment from '../components/pages/departmentdetails/subdepartment/ChildYouthDevelopment';
import DomesticViolenceServices from '../components/pages/departmentdetails/subdepartment/DomesticViolenceServices';
import CommunityEngagementCenters from '../components/pages/departmentdetails/subdepartment/CommunityEngagementCenters';
import SNAP from '../components/pages/departmentdetails/subdepartment/SNAP';
import ABAWD from '../components/pages/departmentdetails/subdepartment/ABAWD';
import EBT from '../components/pages/departmentdetails/subdepartment/EBT';
import SNAPEligibility from '../components/pages/departmentdetails/subdepartment/SNAPEligibility';
import HigherEducation from '../components/pages/departmentdetails/subdepartment/HigherEducationGTSU';
import YouthDevelopmentMentorship from '../components/pages/departmentdetails/subdepartment/YouthDevelopmentMentorship';
import AfterSchoolPrograms from '../components/pages/departmentdetails/subdepartment/AfterSchoolPrograms';
import SpecialEducationSupport from '../components/pages/departmentdetails/subdepartment/SpecialEducationSupport';
import VeteransHealthWellness from '../components/pages/departmentdetails/subdepartment/VeteransHealthWellness';
import VeteransJobTraining from '../components/pages/departmentdetails/subdepartment/VeteransJobTraining';
import VeteransHousingAssistance from '../components/pages/departmentdetails/subdepartment/VeteransHousingAssistance';
import VeteransBenefitsClaims from '../components/pages/departmentdetails/subdepartment/VeteransBenefitsClaims';
import DigitalTransformation from '../components/pages/departmentdetails/subdepartment/DigitalTransformation';
import PublicSectorITSupport from '../components/pages/departmentdetails/subdepartment/PublicSectorITSupport';
import DataSecurityPrivacy from '../components/pages/departmentdetails/subdepartment/DataSecurityPrivacy';
import CitizenFocusedDigitalServices from '../components/pages/departmentdetails/subdepartment/CitizenFocusedDigitalServices';
import SeniorHealthWellness from '../components/pages/departmentdetails/subdepartment/SeniorHealthWellness';
import SocialRecreationalSeniors from '../components/pages/departmentdetails/subdepartment/SocialRecreationalSeniors';
import ElderCareSupport from '../components/pages/departmentdetails/subdepartment/ElderCareSupport';
import SeniorHousingAssistance from '../components/pages/departmentdetails/subdepartment/SeniorHousingAssistance';
import DisasterPreparednessTraining from '../components/pages/departmentdetails/subdepartment/DisasterPreparednessTraining';
import EmergencyResponseRecovery from '../components/pages/departmentdetails/subdepartment/EmergencyResponseRecovery';
import PublicAlertsWarnings from '../components/pages/departmentdetails/subdepartment/PublicAlertsWarnings';
import CommunityResilienceRecovery from '../components/pages/departmentdetails/subdepartment/CommunityResilienceRecovery';
import LicenseRenewal from '../components/pages/departmentdetails/subdepartment/LicenseRenewal';
import DrivingTests from '../components/pages/departmentdetails/subdepartment/DrivingTests';
import IDCards from '../components/pages/departmentdetails/subdepartment/IDTests';
import VehicleRegistration from '../components/pages/departmentdetails/subdepartment/VehicleRegistration';

// Services Pages
// import FamilyAssistance from '../components/pages/servicesdetails/FamilyAssistance';
// import MentalHealthResources from '../components/pages/servicesdetails/MentalHealth';
// import FireAndRescue from '../components/pages/servicesdetails/FireAndRescue';
// import AffordableHousing from '../components/pages/servicesdetails/AffordableHousing';
// import RentalAssistance from '../components/pages/servicesdetails/RentalAssistance';
// import HomeownershipResources from '../components/pages/servicesdetails/HomeownershipResources';
// import UnemploymentAssistance from '../components/pages/servicesdetails/UnemploymentAssistance';
// import EmployerResources from '../components/pages/servicesdetails/EmployerResources';
// import FamilySupportPrograms from '../components/pages/servicesdetails/FamilySupportPrograms';
// import VeteransHealthServices from '../components/pages/servicesdetails/VeteransHealthServices';
// import SeniorHealthWellnessService from '../components/pages/servicesdetails/SeniorHealthWellness';
// import EmergencyResponseRecoveryService from '../components/pages/servicesdetails/EmergencyResponseRecovery';

import Events from '../components/pages/events/Main';
import Eventdetails from '../components/pages/eventsdetails/Main';
import News from '../components/pages/News/Main';
import Newsdetails from '../components/pages/newsdetails/Main';
import Contact from '../components/contact/Main';
import Case from '../components/case/Main';
import Home from '../components/home/Main';
import Login from '../components/login/page';
import LoginAWS from '../components/loginAWS/Main';
import Profile from '../components/loginAWS/Profile/Main';

function Index() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const navigate = useNavigate();

  const handleNavigation = (newPath) => {
    setCurrentPath(newPath); // Update the current path in state
    navigate(newPath); // Perform the navigation
  };

  return (
    <>
      <NavigationProvider value={{ currentPath, handleNavigation }}>
        {/* Render HeaderSwitcher once at app level so it persists across route changes */}
        <HeaderSwitcher />
        <Routes>
          {/* General Routes */}
          <Route path="/" element={<Home />} />
          {/* <Route path="/hometwo" element={<Hometwo />} /> */}
          <Route path="/about" element={<Pageabout />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/team" element={<Team />} />
          <Route path="/teamdetails" element={<Teamdetails />} />
          {/* <Route path="/portfolio" element={<Portfolio />} /> */}
          {/* <Route path="/portfoliodetails" element={<Portfoliodetails />} /> */}
          {/* <Route path="/causes" element={<Causes />} /> */}
          {/* <Route path="/causedetails" element={<Causesdetails />} /> */}
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/forms" element={<Forms />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login-aws" element={<LoginAWS />} />
          <Route path="/profile" element={<Profile />} />

          {/* Forms */}
          <Route path="/forms/commercial-building" element={<CommercialPermit />} />
          <Route path="/forms/one-two-family" element={<CombinationFamilyPermit />} />
          <Route path="/forms/snap" element={<FamilyAssistanceApplication />} />
          <Route path="/forms/medicaid-chip" element={<MedicaidChipApplication />} />
          <Route path="/forms/undergrad" element={<UndergradAdmissionApplication />} />
          <Route path="/forms/grad" element={<GraduateAdmissionApplication />} />
          <Route path="/forms/license-id-update" element={<LicenseIdUpdateApplication />} />
          <Route path="/forms/title-registration" element={<TitleRegistration />} />
          

          {/* Services Routes */}
          {/* <Route path="/services/family-assistance" element={<FamilyAssistance />} />
          <Route path="/services/mental-health" element={<MentalHealthResources />} />
          <Route path="/services/fire-rescue" element={<FireAndRescue />} />
          <Route path="/services/affordable-housing" element={<AffordableHousing />} />
          <Route path="/services/rental-assistance" element={<RentalAssistance />} />
          <Route path="/services/homeownership-resources" element={<HomeownershipResources />} />
          <Route path="/services/unemployment-assistance" element={<UnemploymentAssistance />} />
          <Route path="/services/employer-resources" element={<EmployerResources />} />
          <Route path="/services/family-support-programs" element={<FamilySupportPrograms />} />
          <Route path="/services/veterans-health" element={<VeteransHealthServices />} />
          <Route path="/services/senior-health-wellness" element={<SeniorHealthWellnessService />} />
          <Route path="/services/emergency-response" element={<EmergencyResponseRecoveryService />} /> */}

          {/* Department Routes */}
          <Route path="/department/housing" element={<Housing />} />
          <Route path="/department/public-safety" element={<PublicSafety />} />
          <Route path="/department/emergency" element={<EmergencyManagement />} />
          <Route path="/department/education" element={<EducationYouthServices />} />
          <Route path="/department/employment" element={<EmploymentWorkforce />} />
          <Route path="/department/family-services" element={<FamilyCommunityServices />} />
          <Route path="/department/technology" element={<InnovationTechnology />} />
          <Route path="/department/veterans" element={<VeteransAffairs />} />
          <Route path="/department/health" element={<HealthHumanServices />} />
          <Route path="/department/senior-services" element={<SeniorServices />} />
          <Route path="/department/dmv" element={<DMV />} />

          {/* Sub-Department Routes */}
          <Route path="/department/health/initiatives" element={<PublicHealthInitiatives />} />
          <Route path="/department/health/mental-health-services" element={<MentalHealthAndSubstanceAbuse />} />
          <Route path="/department/health/family-community-health" element={<FamilyCommunityHealth />} />
          <Route path="/department/health/emergency-health-response" element={<EmergencyHealthResponse />} />
          <Route path="/department/public-safety/community-policing" element={<CommunityPolicing />} />
          <Route path="/department/public-safety/fire-rescue" element={<FireRescue />} />
          <Route path="/department/public-safety/traffic-safety" element={<TrafficRoadSafety />} />
          <Route path="/department/public-safety/disaster-response" element={<DisasterResponseRecovery />} />
          <Route path="/department/housing/affordable-housing-programs" element={<AffordableHousingPrograms />} />
          <Route path="/department/housing/community-development" element={<CommunityDevelopmentRevitalization />} />
          <Route path="/department/housing/tenant-rights" element={<TenantRightsRentalAssistance />} />
          <Route path="/department/housing/zoning-permits" element={<ZoningPermits />} />
          <Route path="/department/employment/job-training" element={<JobTrainingSkills />} />
          <Route path="/department/employment/youth-employment" element={<YouthStudentEmployment />} />
          <Route path="/department/employment/career-counseling" element={<CareerCounselingJobPlacement />} />
          <Route path="/department/employment/employer-partnerships" element={<EmployerPartnershipsResources />} />
          <Route path="/department/family-services/family-support" element={<FamilySupportWelfare />} />
          <Route path="/department/family-services/child-youth-development" element={<ChildYouthDevelopment />} />
          <Route path="/department/family-services/domestic-violence-services" element={<DomesticViolenceServices />} />
          <Route path="/department/family-services/community-engagement" element={<CommunityEngagementCenters />} />
          <Route path="/department/family-services/snap" element={<SNAP />} />
          <Route path="/department/family-services/snap/abawd" element={<ABAWD />} />
          <Route path="/department/family-services/snap/ebt" element={<EBT />} />
          <Route path="/department/family-services/snap/snap-eligibility" element={<SNAPEligibility />} />
          <Route path="/department/education/gtsu" element={<HigherEducation />} />
          <Route path="/department/education/youth-mentorship" element={<YouthDevelopmentMentorship />} />
          <Route path="/department/education/after-school-programs" element={<AfterSchoolPrograms />} />
          <Route path="/department/education/special-education-support" element={<SpecialEducationSupport />} />
          <Route path="/department/veterans/health-wellness" element={<VeteransHealthWellness />} />
          <Route path="/department/veterans/job-training" element={<VeteransJobTraining />} />
          <Route path="/department/veterans/housing-support" element={<VeteransHousingAssistance />} />
          <Route path="/department/veterans/benefits-claims" element={<VeteransBenefitsClaims />} />
          <Route path="/department/technology/digital-transformation" element={<DigitalTransformation />} />
          <Route path="/department/technology/it-support" element={<PublicSectorITSupport />} />
          <Route path="/department/technology/data-security" element={<DataSecurityPrivacy />} />
          <Route path="/department/technology/digital-services" element={<CitizenFocusedDigitalServices />} />
          <Route path="/department/senior-services/health-wellness" element={<SeniorHealthWellness />} />
          <Route path="/department/senior-services/social-activities" element={<SocialRecreationalSeniors />} />
          <Route path="/department/senior-services/elder-care" element={<ElderCareSupport />} />
          <Route path="/department/senior-services/housing" element={<SeniorHousingAssistance />} />
          <Route path="/department/emergency/disaster-preparedness" element={<DisasterPreparednessTraining />} />
          <Route path="/department/emergency/emergency-response" element={<EmergencyResponseRecovery />} />
          <Route path="/department/emergency/public-alerts" element={<PublicAlertsWarnings />} />
          <Route path="/department/emergency/community-resilience" element={<CommunityResilienceRecovery />} />
          <Route path="/department/dmv/license-renewal" element={<LicenseRenewal />} />
          <Route path="/department/dmv/vehicle-registration" element={<VehicleRegistration />} />
          <Route path="/department/dmv/driving-tests" element={<DrivingTests />} />
          <Route path="/department/dmv/id-cards" element={<IDCards />} />

          <Route path="/events" element={<Events />} />
          <Route path="/eventdetails" element={<Eventdetails />} />
          <Route path="/news" element={<News />} />
          <Route path="/newsdetails" element={<Newsdetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/report-issue" element={<Case />} />

          {/* Fallback Route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </NavigationProvider>
      <Footer />
    </>
  );
}

export default Index;